import { primaryColor } from "../../utils/theme";
import { Box, Table, TableHead, TableBody, TableCell } from "@mui/material";
import { alpha, styled } from "@mui/material/styles"; // Note the import change

export const PageWrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  // minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column', // Add this to stack content vertically
  // justifyContent: 'center', // <--- REMOVE THIS LINE
  width: '100%', // <--- ADD THIS to ensure the wrapper itself is full width
  alignItems: 'flex-start',
  fontFamily: "'Roboto', sans-serif",
}));

export const HeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '30px',
}));

// table styles

export const StyledTableContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.grey[200]}`,
  overflowX: 'auto',
  boxShadow: 'none',
}));

export const StyledTable = styled(Table)({
  borderCollapse: 'separate',
  borderSpacing: 0,
});

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light, 
  
  '& th': {
    backgroundColor: 'inherit',
    color: theme.palette.custom.sidebarText,
    fontWeight: 600,
    fontSize: '0.85rem',
    borderBottom: 'none',
    padding: theme.spacing(1.5, 2),
  },
}));

export const StyledTableBody = styled(TableBody)(({ theme }) => ({
  '& tr:nth-of-type(odd)': {
    backgroundColor: theme.palette.white.main, // White rows
  },
  '& tr:nth-of-type(even)': {
    backgroundColor: theme.palette.primary.light, // Very light grey stripe
  },
  '& tr:last-child td': {
    borderBottom: 0,
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.85rem',
  color: theme.palette.custom.sidebarText,
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  padding: theme.spacing(1.5, 2),
}));

export const PaginationFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: theme.spacing(2), 
  color: theme.palette.grey[600],
  fontSize: '0.85rem',
  paddingBottom: 0,
}));

interface StatusTagProps {
  status: 'Active' | 'Pending' | 'Blocked' | string;
}

export const StatusTag = styled(Box)<StatusTagProps>(({ theme, status }) => {
  let bgColor: string;
  let color: string;

  switch (status) {
    case 'Active':
    case 'Completed':
      bgColor = alpha(primaryColor, 0.15);
      color = primaryColor;
      break;
    case 'paid':
      bgColor = alpha(theme.palette.success.main, 0.15);
      color = theme.palette.success.main;
      break;
    case 'unpaid':
      bgColor = alpha(theme.palette.error.main, 0.15);
      color = theme.palette.error.main;
      break;
    case 'Partially Paid':
      bgColor = alpha(theme.palette.warning.light, 0.5);
      color = theme.palette.warning.dark;
      break;
    case 'Pending':
      bgColor = alpha(theme.palette.warning.light, 0.5);
      color = theme.palette.warning.dark;
      break;
    case 'Cancelled':
      bgColor = alpha(theme.palette.error.main, 0.15);
      color = theme.palette.error.main;
      break;
    case 'Upcoming':
      bgColor = alpha(theme.palette.link.main, 0.15);
      color = theme.palette.link.main;
      break;
    default:
      bgColor = theme.palette.grey[100];
      color = theme.palette.grey[600];
  }

  return {
    backgroundColor: bgColor,
    color: color,
    fontWeight: 600,
    fontSize: '0.75rem',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: '4px',
    textAlign: 'center',
    width: 'fit-content',
    float: "left",
    margin: "0 auto",
  };
});